module.exports = __webpack_public_path__ + "static/waxman-logo-c343c8a326c8771523f4db3a6ce68172.jpg";